import styled from 'styled-components';

// ---------------------------------------------------------------------------
// Estilos do MultiSelectDropdown.
//
// Geometria alinhada aos controles de filtro do DS: gatilho de 34px (mesmo
// porte de chip/segmented), raio 10 em controle, 999 em pill, foco com o anel
// azul padrão. Nada de cor de ação aqui — o dropdown é consultivo (FC7 G.1).
// ---------------------------------------------------------------------------

const CONTROL_BORDER = 'rgba(0, 0, 0, 0.12)';
const FOCUS_RING = '0 0 0 3px rgba(64, 152, 239, 0.18)';

export const Root = styled.div`
   position: relative;
   display: inline-block;
   min-width: 0;
`;

export const Trigger = styled.button`
   display: inline-flex;
   align-items: center;
   gap: 8px;
   height: 34px;
   max-width: 100%;
   padding: 0 12px;
   border-radius: 10px;
   border: 1px solid
      ${({ $active, theme }) =>
         $active ? theme?.colors?.primary ?? '#4098ef' : CONTROL_BORDER};
   background: #fff;
   font-size: 12px;
   font-weight: 700;
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
   cursor: pointer;
   transition: border-color 140ms ease, background 140ms ease;

   /* ⚠️ background repetido de propósito: o GlobalStyles tem uma regra
      button:hover com background-color, cuja especificidade (0,0,1,1) vence a
      classe do styled-component (0,0,1,0). Sem isto o gatilho pisca no azul do
      legado. Vale para todo styled.button do app. */
   &:hover {
      background: #fff;
      border-color: rgba(0, 0, 0, 0.24);
   }

   &:focus-visible {
      outline: none;
      box-shadow: ${FOCUS_RING};
   }

   svg {
      flex-shrink: 0;
      color: #8a8a8a;
   }
`;

export const TriggerLabel = styled.span`
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
`;

// Contador do que está selecionado — a informação que o gatilho fechado
// precisa carregar para o filtro não virar caixa-preta.
export const CountBadge = styled.span`
   flex-shrink: 0;
   padding: 1px 7px;
   border-radius: 999px;
   background: ${({ theme }) => theme?.colors?.primary ?? '#4098ef'};
   color: #fff;
   font-size: 10.5px;
   font-weight: 800;
   font-variant-numeric: tabular-nums;
`;

export const Popover = styled.div`
   position: absolute;
   z-index: 30;
   top: calc(100% + 6px);
   left: 0;
   width: max(260px, 100%);
   max-width: 340px;
   background: #fff;
   border: 1px solid rgba(0, 0, 0, 0.12);
   border-radius: 12px;
   box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
   overflow: hidden;
`;

export const SearchRow = styled.div`
   padding: 10px 10px 8px;
   border-bottom: 1px solid rgba(0, 0, 0, 0.07);
`;

export const SearchInput = styled.input`
   width: 100%;
   height: 32px;
   padding: 0 10px;
   border-radius: 8px;
   border: 1px solid ${CONTROL_BORDER};
   font-size: 12.5px;
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};

   &:focus-visible {
      outline: none;
      border-color: ${({ theme }) => theme?.colors?.primary ?? '#4098ef'};
      box-shadow: ${FOCUS_RING};
   }
`;

export const OptionList = styled.div`
   max-height: 268px;
   overflow-y: auto;
   padding: 6px;
`;

export const Option = styled.label`
   display: flex;
   align-items: center;
   gap: 9px;
   padding: 7px 9px;
   border-radius: 8px;
   font-size: 12.5px;
   line-height: 1.35;
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
   cursor: pointer;

   &:hover {
      background: #f3f8fe;
   }

   input {
      flex-shrink: 0;
      width: 15px;
      height: 15px;
      margin: 0;
      accent-color: ${({ theme }) => theme?.colors?.primary ?? '#4098ef'};
      cursor: pointer;
   }

   /* O anel de foco vai no rótulo inteiro: o checkbox nativo de 15px é alvo
      pequeno demais para o foco de teclado ser percebido. */
   &:focus-within {
      background: #f3f8fe;
      box-shadow: inset ${FOCUS_RING};
   }
`;

export const EmptyOption = styled.p`
   margin: 0;
   padding: 14px 10px;
   text-align: center;
   font-size: 12px;
   color: #8a8a8a;
`;

export const Footer = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 8px;
   padding: 8px 10px;
   border-top: 1px solid rgba(0, 0, 0, 0.07);
   background: #fcfcfd;
   font-size: 11px;
   color: #8a8a8a;
`;
